import React from "react";
import { View } from "react-native";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../const";
import { PrimarySubtitle } from "../labels";

export default function RateBox({ rate }) {
    return (
        <View style={{
            shadowOpacity: 0.1, shadowRadius: 6,
            elevation: 1,
            shadowColor: colors.black,
            flexDirection: "row",
            backgroundColor: colors.white,
            borderRadius: 6,
            justifyContent: "center",
            alignItems: "center",
            padding: 10,
            paddingVertical: 15,
            maxHeight: 45
        }}>
            <Icon
                icon={faStar}
                color={colors.yellow}
                style={{position: "static", fontSize: 18}}
            />
            <PrimarySubtitle style={{fontWeight: "bold", paddingLeft: 10}}>
                + {rate}
            </PrimarySubtitle>
        </View>
    )
}